import { Button, TableItem } from 'components/atoms';
import { Table, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { useInfiniteTable } from 'hooks/useInfiniteTable';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetProvidersInfiniteList } from 'services/providers';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { usePermissionGuard } from "hooks/usePermissionGuard";
import { useHasPermission } from 'hooks';

const Providers = () => {
  usePermissionGuard('ProvidersPermissionsLIST**');
  const hasPermission = useHasPermission();

  const { t } = useTranslation();
  const navigate = useNavigate();
  const providers = useGetProvidersInfiniteList({});

  const tableProps = useInfiniteTable(providers);

  return (
    <TopbarPage
      topbar={
        <TopBar
          title={t('provider.title.list')}
          hideBackButton
          topbarContent={
            hasPermission('ProvidersPermissionsLIST**', 1) && (
              <Button
                variant={BUTTON_VARIANT.submit}
                onClick={() => navigate('create')}>
                <Button.Text
                  text={t(`button.create-what`, { what: t('provider.what') })}
                />
              </Button>
            )
          }
        />
      }>
      <Table
        id={"Providers"}
        {...tableProps}
        columns={[
          {
            label: t('input.label.name'),
            renderCell: ({ name }) => (
              <TableItem>
                <TableItem.Text text={name} />
              </TableItem>
            ),
            resize: true,
          },
          {
            label: t('input.label.salesChannel'),
            renderCell: ({ salesChannels }) => (
              <TableItem>
                <TableItem.List items={salesChannels}>
                  {item => <TableItem.Text text={item.name} isSupplementary />}
                </TableItem.List>
              </TableItem>
            ),
          },
        ]}
        displayMode
      />
    </TopbarPage>
  );
};

export default Providers;
